import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const LOGO = "https://customer-assets.emergentagent.com/job_44ba2ac7-0b1c-4eed-9431-48d083bd72e5/artifacts/j93m24ek_b3a24f9f-e8bf-430c-b29d-3bcab14f66ae.png";

const GUEST_NAV = [
  ["/services", "Services"],
  ["/book", "Book a job"],
  ["/trades", "Our trades"],
  ["/about", "Our standard"],
  ["/partners", "Partner with us"],
];

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = async () => { await logout(); navigate("/"); };

  const dashPath = user?.role === "trade" ? "/dashboard" : "/dashboard";
  const nav = user
    ? (user.role === "trade"
        ? [["/dashboard", "Overview"], ["/trades", "Our trades"], ["/about", "Our standard"]]
        : [["/dashboard", "Dashboard"], ["/book", "Book a job"], ["/trades", "Our trades"], ["/about", "Our standard"]])
    : GUEST_NAV;

  return (
    <header className="od-site-header" style={{ position: "sticky", top: 0, zIndex: 40, background: "rgba(251,246,241,.92)", backdropFilter: "blur(8px)", borderBottom: "1px solid var(--hairline)" }}>
      <div className="od-wrap" style={{ height: 74, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Link to="/" data-testid="header-logo" style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <img src={LOGO} alt="Olivia Does" style={{ width: 38, height: 38, borderRadius: "50%", objectFit: "cover" }} />
          <div style={{ fontFamily: "'Fraunces', serif", fontSize: "1.35rem" }}>
            Olivia<span style={{ fontFamily: "'Work Sans'", fontSize: ".68rem", letterSpacing: ".16em", color: "var(--taupe)", marginLeft: 6, verticalAlign: "middle" }}>DOES</span>
          </div>
        </Link>

        <nav className="od-desktop-nav" style={{ display: "flex", gap: 30, fontSize: ".92rem" }}>
          {nav.map(([to, label]) => (
            <NavLink key={to} to={to} data-testid={`nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) => `od-navlink ${isActive ? "active" : ""}`}
              style={({ isActive }) => ({ color: "var(--charcoal)", opacity: isActive ? 1 : 0.82, padding: "6px 0", borderBottom: `2px solid ${isActive ? "var(--rose)" : "transparent"}` })}>
              {label}
            </NavLink>
          ))}
        </nav>

        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          {user ? (
            <>
              <Link to="/account" data-testid="header-account-link" className="od-user-name" style={{ fontSize: ".85rem", color: "var(--taupe)", textDecoration: "none" }}>{user.name?.split(" ")[0]}</Link>
              <button data-testid="header-logout-btn" onClick={onLogout} className="btn secondary sm">Log out</button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="header-login-link" className="btn ghost sm">Sign in</Link>
              <Link to="/register" data-testid="header-register-link" className="btn primary sm">Join Olivia</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
